/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/ChallengeAuthorities/PlayCardDailyFreeCellAuthority',[
    'SolitaireShared/FreeCellLogic/FreeCellAuthority',
    'SolitaireShared/FreeCellLogic/IDailyFreeCellAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/IPlayCardDailyAuthority',
    'SolitaireShared/CardLogic/CardOp'
], function (FreeCellAuthority, IDailyFreeCellAuthority, IDailyAuthority, IPlayCardDailyAuthority, CardOp) {
    "use strict";

    var PlayCardDailyFreeCellAuthority = function (param) {
        this.initPlayCardDailyFreeCellAuthority(param);
    };

    PlayCardDailyFreeCellAuthority.constructor = PlayCardDailyFreeCellAuthority;
    PlayCardDailyFreeCellAuthority.prototype = Object.create(IDailyFreeCellAuthority.prototype);
    IPlayCardDailyAuthority.call(PlayCardDailyFreeCellAuthority.prototype);


    Object.defineProperty(PlayCardDailyFreeCellAuthority.prototype, "NumberPlayed",  {
        get: function () {
            return this.CardPlayed() ? 1 : 0;
        }
    });

    PlayCardDailyFreeCellAuthority.KeyCardToPlay =  "CARDTOPLAY";

    /// <summary>
    /// Constructs a daily challenge authority which implements the win condition "Play card x to foundation"
    /// </summary>
    /// <param name="param">String value of card which must be played</param>
    PlayCardDailyFreeCellAuthority.prototype.initPlayCardDailyFreeCellAuthority = function (param) {
        IDailyFreeCellAuthority.call(this);

        if (param != null && param[PlayCardDailyFreeCellAuthority.KeyCardToPlay])
            this._cardToPlay = this.GetCardValue(param[PlayCardDailyFreeCellAuthority.KeyCardToPlay].toUpperCase());
        else throw "Invalid parameter passed in creating Daily Challenge";

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayCard;
    };


    PlayCardDailyFreeCellAuthority.prototype.IsGameWon = function ()
    {
        var pile = null;
        for (var i = 0; i < 4; i++)
        {
            pile = this.CardSupply.GetPile("Foundation" + i);
            if (!pile.Empty && pile.Top.ToString() == this._cardToPlay)
            {
                this.cardPlayed = true;
                return true;
            }
        }

        return IDailyFreeCellAuthority.prototype.IsGameWon.call(this);
    };

    PlayCardDailyFreeCellAuthority.prototype.GetHint = function (cycle, cheat)
    {

        if(cheat) {
            return IDailyFreeCellAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;

        var numTableaus = 8;
        var numFrees = 4;

        var hints = [];

        var a, b;
        var foundation = this.CardSupply.GetPile("Foundation");
        var cards = [];
        cards.push("CHALLENGE");

        // Tableau-a-tableau matches first.
        for (var i = numTableaus - 1; i >= 0; i--)
        {
            a = this.CardSupply.GetPile("Tableau" + i);
            if (a.Empty)
                continue;

            // Shortcut if we find an unblocked King.
            var pileCards = a.GetCards();
            for (var ci = 0; ci < pileCards.length; ci++)
            {
                var c = pileCards[ci];
                if (c.ToString() == this._cardToPlay)
                {
                    cards.push(c.Sequence.toString());

                    break;
                }
            }
        }
        if (cards.length <= 1)
        {
            for (var i = 0; i < numFrees; i++)
            {
                a = this.CardSupply.GetPile("Free" + i);
                if (a.Empty)
                    continue;

                // Shortcut if we find an unblocked King.
                if (a.Top.ToString() == this._cardToPlay)
                {
                    // Note: the actually legal move would be a-to-foundation
                    // but the foundation is invisible in Pyramid.

                    cards.push(a.Top.Sequence.toString());

                    break;
                }
            }
        }

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

 /*   PlayCardDailyFreeCellAuthority.prototype.GetCardValue = function (card)
    {
        var value = parseInt(card.substring(0, 2));
        if (!isNaN(value))
        {
            return "T" + card[card.length - 1];
        }
        return card;
    };
*/
    PlayCardDailyFreeCellAuthority.prototype.GetCardValue = function (card)
    {
        return card;
    };


    return PlayCardDailyFreeCellAuthority;
});
